module.exports = global.config = {
    candidatelogin: process.env.REACT_APP_CANDIDATE_LOGIN,
    companylogin: process.env.REACT_APP_COMPANY_LOGIN,
    candidatesignup: process.env.REACT_APP_CANDIDATE_SIGNUP,
    companysignup: process.env.REACT_APP_COMPANY_SIGNUP,
}